import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import { BUSINESS } from "@/lib/constants";

export default function Contact() {
  return (
    <section
      id="kapcsolat"
      data-testid="contact-section"
      className="velvet-cream py-24 md:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-12 md:gap-20 items-start">
          <div className="md:col-span-7">
            <div className="overline mb-6 flex items-center">
              <span className="gold-rule" />
              Kapcsolat
            </div>
            <h2 className="font-serif-display text-4xl md:text-6xl leading-[1.05] text-[#0A1228] mb-12">
              Beszéljünk
              <span className="italic text-[#1E47A8]"> személyesen.</span>
            </h2>

            <div className="space-y-10">
              <a
                href={`tel:${BUSINESS.phoneTel}`}
                data-testid="contact-phone"
                className="group block border-t border-[#0A1228]/15 pt-7"
              >
                <div className="overline mb-3 flex items-center gap-2">
                  <Phone size={11} /> Telefon
                </div>
                <div className="font-serif-display text-5xl md:text-7xl text-[#0A1228] group-hover:text-[#1E47A8] transition-colors leading-none tracking-tight">
                  {BUSINESS.phoneDisplay}
                </div>
                <div className="text-xs text-[#4A5468] mt-4 tracking-[0.2em] uppercase">
                  H–P: 8:00–18:00 · Szo: 8:00–13:00
                </div>
              </a>

              <a
                href={`mailto:${BUSINESS.email}`}
                data-testid="contact-email"
                className="group block border-t border-[#0A1228]/15 pt-7"
              >
                <div className="overline mb-3 flex items-center gap-2">
                  <Mail size={11} /> E-mail
                </div>
                <div className="font-serif-display text-2xl md:text-4xl text-[#0A1228] group-hover:text-[#1E47A8] transition-colors break-all">
                  {BUSINESS.email}
                </div>
              </a>

              <div className="border-t border-[#0A1228]/15 pt-7">
                <div className="overline mb-3 flex items-center gap-2">
                  <MapPin size={11} /> Szolgáltatási terület
                </div>
                <div className="font-serif-display text-2xl md:text-4xl text-[#0A1228]">
                  Monor és Pest megye
                </div>
                <div className="text-sm text-[#4A5468] mt-2 font-light">
                  Igény szerint helyszíni felmérés.
                </div>
              </div>
            </div>
          </div>

          <div className="md:col-span-5">
            <div className="relative">
              <div className="absolute -top-4 -left-4 w-24 h-24 border-l border-t border-[#B8935A]/60 hidden md:block" />
              <div className="absolute -bottom-4 -right-4 w-24 h-24 border-r border-b border-[#B8935A]/60 hidden md:block" />
              <div className="bg-[#0A1228] aspect-[4/5] flex items-center justify-center p-12">
                <img
                  src={BUSINESS.logoUrl}
                  alt="KL Kárpitos"
                  className="w-full max-w-xs h-auto"
                />
              </div>
            </div>
          </div>
        </div>

        <footer className="mt-24 md:mt-32 border-t border-[#0A1228]/15 pt-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <div className="flex items-center gap-3">
            <img src={BUSINESS.logoUrl} alt="" className="h-10 w-auto" />
            <div>
              <div className="font-serif-display text-xl text-[#0A1228]">
                {BUSINESS.name}
              </div>
              <div className="text-[10px] tracking-[0.3em] uppercase text-[#1E47A8] mt-0.5">
                Bútorfelújítás · Monor
              </div>
            </div>
          </div>
          <p className="text-xs text-[#4A5468] tracking-wide">
            © {new Date().getFullYear()} KL Kárpitos — Minden jog fenntartva
          </p>
        </footer>
      </div>
    </section>
  );
}
